import { InputIuguCreditCard } from "@scrile/api-provider/dist/api/IuguPurchaseProvider";
import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import { PurchaseSubjectTypeEnum } from "@scrile/api-provider/dist/api/PurchaseTypeProvider";
import { Subject } from "@scrile/api-provider/dist/api/SubjectProvider";
import { Subscription } from "@scrile/api-provider/dist/api/SubscriptionProvider";
import { Transaction } from "@scrile/api-provider/dist/api/TransactionProvider";
import providers from "@/lib/api";
import { $t } from "@/lib/i18nHelpers";
import config from "@/config";
import paymentComponent from "./Iugu.vue";
import { IntegrationModule } from "../types";

interface PaymentData {
  billingDetails: InputIuguCreditCard;
  type?: string;
  purchaseSubject?: Subject<PurchaseSubjectTypeEnum>;
}

const integrationModule: IntegrationModule<PaymentData | undefined> = {
  paymentComponent,
  purchase: async (data, paymentData) => {
    const subjectPurchased = !!paymentData?.purchaseSubject;
    if (paymentData?.type === "creditCard") {
      providers.IuguPurchaseProvider.setTestMode(config.featureIuguPaymentSystem === "testMode");
      const transaction: Transaction = await providers.IuguPurchaseProvider.purchaseDeposit({
        data: { ...data, billingDetails: paymentData?.billingDetails, subject: paymentData?.purchaseSubject },
      });
      return {
        status: true,
        subjectPurchased,
        transaction,
      };
    }
    if (["pix", "boleto"].includes(paymentData?.type ?? "")) {
      return {
        status: true,
        subjectPurchased,
        transaction: undefined,
      };
    }
    return {
      status: false,
      subjectPurchased: false,
      transaction: undefined,
    };
  },
  subscribe: async (data, paymentData) => {
    if (paymentData?.type === "creditCard") {
      providers.IuguPurchaseProvider.setTestMode(config.featureIuguPaymentSystem === "testMode");
      const subscription: Subscription = await providers.IuguPurchaseProvider.purchaseRecurring({
        data: {
          ...data,
          billingDetails: paymentData?.billingDetails,
        },
      });
      return {
        status: true,
        subjectPurchased: true,
        subscription,
      };
    }
    if (["pix", "boleto"].includes(paymentData?.type ?? "")) {
      return {
        status: true,
        subjectPurchased: true,
        subscription: undefined,
      };
    }
    return {
      status: false,
      subjectPurchased: false,
      subscription: undefined,
    };
  },
  allowSaveCard: true,
  forceShowUI: true,
  name: $t("Iugu"),
  logo: "/img/paymentSystems/iugu.svg",
};

export const selector = (system: PaymentSystemPublic | null): boolean => {
  return system?.type === "iugu" ?? false;
};

export default integrationModule;
